module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ssTabList2"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [(_vm.role == 'press') ? _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位提交")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookName))])]) : _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.bookName))]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "tabElement"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tabDat), function(term, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v(_vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(term.updatedAt, "time")))]), _vm._v(" "), _c('td', [(term.code != 501) ? _c('span', [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term)
        }
      }
    }, [_vm._v("查看")])], 1) : _vm._e(), _vm._v(" "), (term.code == 501) ? _c('span', [(term.status == 2) ? _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "warning"
      }
    }, [_c('a', {
      attrs: {
        "download": ""
      },
      on: {
        "click": function($event) {
          _vm.filesDown(term)
        }
      }
    }, [_vm._v("下载")])]) : _vm._e(), _vm._v(" "), (term.status != 2) ? _c('el-button', {
      attrs: {
        "size": "mini",
        "disabled": ""
      }
    }, [_vm._v(" 未上传 ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (inx == 0) ? _c('td', [(term.code == '402') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : (inx == 1) ? _c('td', [(term.code == '401') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : (inx == 2) ? _c('td', {
      attrs: {
        "rowspan": "3"
      }
    }, [_vm._v(" ")]) : (inx == 5) ? _c('td', [_vm._v(" ")]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.role == 'press') ? _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物出版情况登记表")]), _vm._v(" "), _c('td', [_vm._v("查阅时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7451a0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/ssCommonTabs.vue
// module id = 1789
// module chunks = 1